import { isObject } from "@helpers/utils.js";
import model from "@js/model.js";

const POLL_INTERVAL = 30000; //30s
// const POLL_INTERVAL = 100; //30s
let pollTimeout = null;
let pollingPaused = false;

export default {
    initOptimove(){
        model.observables.inboxUnreadMsgs = 0;
        model.observables.inboxData = null;

        if(window.optimoveSDK?.API){
            model.dispatchEvent('OptimoveSDKLoaded');
            optimoveSDK.API.setRealTimeOptions({
                reportEventCallback: reportEventCallback.bind(this),
            });
        }

        function reportEventCallback(resp){
            if(!isObject(resp) || !resp.IsSuccess){
                console.warn('Optimove event reporting failed', resp);
                return;
            }

            let data = resp.Data;
            if(!data || typeof data !== 'string') return;

            let emptyContainer = data.includes('data-empty-container="true"');

            this.showNotification({
                title: null,
                text: data,
                shadowRoot: true,
                emptyContainer,
            });
        }

        if(!isObject(model.optimoveConfig)) return;

        if(model.inboxActive){
            model.on('LoginComplete', () => pollInbox.call(this));

            let lastHideState = 0;
            document.addEventListener('visibilitychange', () => {
                if(!model.logged) return;

                if (document.visibilityState === 'visible') {
                    let mills = POLL_INTERVAL - (Date.now() - lastHideState);
                    if(mills < 0) mills = 0;
                    this.resumePolling(mills);
                }
                else{
                    clearTimeout(pollTimeout);
                    lastHideState = Date.now();
                }
            });

            model.on('LogoutComplete', () => {
                model.observables.inboxUnreadMsgs = 0;
                model.observables.inboxData = null;
                clearTimeout(pollTimeout);
            });

            model.on('InboxMessageRead', () => {
                this.resumePolling();
            });
        }
    },
    reportMessageRead(msg){
        if(!window.optimoveSDK?.API) return;
        return optimoveSDK.API.embeddedMessaging.setReadAsync(msg, true);
    },
    deleteMessage(msg){
        if(!window.optimoveSDK?.API) return Promise.resolve();
        return optimoveSDK.API.embeddedMessaging.deleteMessageAsync(msg);
    },
    sendLobbyCommand(lobbyCommand, strValues){
        let params = {};

        if(typeof strValues === 'string') {
            strValues = strValues.split('&');
            strValues.forEach(pair => {
                pair = pair.replace(/\s+/g, '').split('=');
                params[pair[0]] = pair[1];
            });
        }

        let options = {
            brand: model.isUI('FUND') ? 'Fundalor' : 'Skythor',
            command: lobbyCommand,
        };

        Object.assign(options, params);

        if(!window.optimoveSDK?.API) {
            console.log('LOBBY COMMAND:', options);
            return;
        }

        window.optimoveSDK.API.reportEvent('lobby_command', options);
    },
    resumePolling(mills){
        pollingPaused = false;
        clearTimeout(pollTimeout);
        if(!model.logged || document.visibilityState !== 'visible') return;
        pollTimeout = setTimeout(() => pollInbox.call(this), typeof mills === 'undefined' ? POLL_INTERVAL : mills);
    },
    pausePolling(){
        pollingPaused = true;
        clearTimeout(pollTimeout);
    },
}


function pollInbox(){
    if(!model.logged || document.visibilityState !== 'visible' || pollingPaused) return;

    getMessagesAsync().then(data => {
        if(pollingPaused) return;

        let newInboxData = data?.Inbox?.messages;
        if(!Array.isArray(newInboxData)) return;

        model.observables.inboxUnreadMsgs = newInboxData.filter(msg => !msg.readAt).length;

        newInboxData.forEach(msg => {
            if(isObject(msg.payload) && Object.keys(msg.payload).length > 0 && isObject(model.optimoveConfig.msgButtons)){
                msg.buttons = [];
                for(let key in msg.payload){
                    let val = msg.payload[key];

                    if(!Object.keys(model.optimoveConfig.msgButtons).includes(key)) continue;
                    
                    let btn = model.optimoveConfig.msgButtons[key];
                    let text = btn.label;
                    if(isObject(text)) text = model.redeemLangObj(text);
                    else text = model.getStr(text);

                    msg.buttons.push({ 
                        command: btn.command, 
                        val,
                        text, 
                    });
                }
            }

            let existingMsg = model.observables.inboxData?.find(m => m.id === msg.id);
            if(!existingMsg) return;

            msg.open = existingMsg.open;
            if(msg.open) msg.readAt = Date.now();
        });

        model.observables.inboxData = newInboxData;

        this.resumePolling();
    });
}

function getMessagesAsync(){
    if(!window.optimoveSDK?.API) {
        return new Promise(async resolve => {
            const resp = await fetch(`http://localhost:80/optimove-embedded-messages-test/`);
            resolve(await resp.json());
        });
    }

    return optimoveSDK.API.embeddedMessaging.getMessagesAsync();
}